/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React from 'react';

import {isFinite, isNaN} from 'lodash';
import moment from 'moment';
import {connect} from 'react-redux';

import ProgressBar from '@/components/progressBar/Progresbar';
import {PROGRESS_BAR_COMMON_VALUE} from '@/constants/enums';
import * as APPDATA from '@/constants/pcConstAppData';
import {MANUAL_CONTROL_ENUM} from '@/constants/statusManualControlEnum';
import {ConvertSecondsToHHMMSS} from '@/libs/appHelper';
import {eventBusObject} from '@/observers/eventBus';

@connect((store) => ({
  estimateTime: store.setupStore.estimateTime,
  isPCPaused: store.setupStore.isPCPaused,
  isPCRunning: store.setupStore.isPCRunning,
  percentageProgressBar: store.setupStore.percentageProgressBar,
  currentPCState: store.setupStore.currentPCState,
  currentVolume: store.setupStore.currentVolume,
  isSetScheduleRun: store.schedulerState.isSetScheduleRun,
  startTime: store.schedulerState.startTime,
  manualControlStatus: store.manualControlStore.StatusManualControl,
  ManualControlStartVolume: store.manualControlStore.StatusManualControl.StartVolume,
  IsShowManualControlPopUp: store.manualControlStore.IsShowManualControlPopUp,
}))
class StatusProgress extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disableProgressBar: false,
    };
    this._bus = eventBusObject();
  }

  componentDidMount() {
    this.eventManualControlState = this._bus.subscribe(APPDATA.EVENT.TopButtonStatusType, (e) =>
      this.manualControlState(e),
    );
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.estimateTime !== nextProps.estimateTime) return true;
    if (this.props.isPCPaused !== nextProps.isPCPaused) return true;
    if (this.props.isPCRunning !== nextProps.isPCRunning) return true;
    if (this.props.percentageProgressBar !== nextProps.percentageProgressBar) return true;
    if (this.props.currentPCState !== nextProps.currentPCState) return true;
    if (this.props.manualControlStatus.IsManualControlRunning !== nextProps.manualControlStatus.IsManualControlRunning)
      return true;
    if (this.props.manualControlStatus.TotalRunTime !== nextProps.manualControlStatus.TotalRunTime) return true;
    if (this.props.manualControlStatus.CurrentRunTime !== nextProps.manualControlStatus.CurrentRunTime) return true;
    if (this.props.manualControlStatus.IsManualControlEnable !== nextProps.manualControlStatus.IsManualControlEnable)
      return true;
    if (this.props.IsShowManualControlPopUp !== nextProps.IsShowManualControlPopUp) {
      return true;
    }
    if (this.state.disableProgressBar !== nextState.disableProgressBar) return true;
    if (this.props.isSetScheduleRun !== nextProps.isSetScheduleRun) return true;
    if (this.props.startTime !== nextProps.startTime) return true;

    return false;
  }

  componentWillUnmount() {
    this.eventManualControlState.unsubscribe();
  }

  manualControlState = (state) => {
    if (state === MANUAL_CONTROL_ENUM.HOLD_TO_RUN)
      this.setState({
        disableProgressBar: true,
      });
    else
      this.setState({
        disableProgressBar: false,
      });
  };

  // eslint-disable-next-line class-methods-use-this
  IsManualControlEnableButNotRunning = (manualControlStatus) => {
    if (manualControlStatus.IsManualControlEnable === 'true' && manualControlStatus.IsManualControlRunning === 'false')
      return true;
    return false;
  };

  progressBarStyle = () => {
    const {isPCPaused, manualControlStatus, IsShowManualControlPopUp} = this.props;
    if (IsShowManualControlPopUp) {
      return ProgressBar.styles.on_going;
    }
    if (isPCPaused) {
      return ProgressBar.styles.on_hold;
    }
    // when manual control is active but not runnning
    if (this.IsManualControlEnableButNotRunning(manualControlStatus)) return ProgressBar.styles.on_hold;
    return ProgressBar.styles.on_going;
  };

  progressBarLabel = () => {
    const {isPCPaused, currentPCState, manualControlStatus, IsShowManualControlPopUp, isSetScheduleRun, startTime} =
      this.props;
    const textNotRunning = 'IDLE';
    const textComplete = 'FINISH';
    const textManualControl = 'MANUAL CONTROL';
    const isManualControlActiveButNotRunning = !!this.IsManualControlEnableButNotRunning(manualControlStatus);

    let state = currentPCState;
    if (currentPCState === APPDATA.PC_RECOVERING_STATE || currentPCState === APPDATA.PC_DEPRESSURIZING_STATE) {
      state = 'STOPPED';
    } else if (currentPCState === APPDATA.PC_FILL_MEMBRANE) {
      state = APPDATA.PC_PREPARING_STATE;
    }

    const textRunning = `${state} - ${this.percentageProgressbar()}%, ETR : ${
      isPCPaused || isManualControlActiveButNotRunning ? 'Paused' : this.estimateTime()
    }`;

    const isManualControlAvailable =
      IsShowManualControlPopUp &&
      currentPCState !== APPDATA.PC_IDLE_STATE &&
      currentPCState !== APPDATA.PC_STOPPING_STATE;

    const progressBarLabel =
      {
        [APPDATA.PC_STOPPING_STATE]: textComplete,
        [APPDATA.PC_IDLE_STATE]: textNotRunning,
        default: textRunning,
      }[currentPCState] || textRunning;

    let displayedLabel = progressBarLabel;
    if (isSetScheduleRun) {
      const parsedStartTime = `${moment(startTime).format('L')} ${moment(startTime).format('LT')}`;
      displayedLabel = `${progressBarLabel} - SCHEDULED AT ${parsedStartTime}`;
    }

    return isManualControlAvailable ? textManualControl : displayedLabel;
  };

  estimateTime = () => {
    const {estimateTime, manualControlStatus} = this.props;

    const normalEstimateTime = estimateTime;
    const manualControlEstimateTime = ConvertSecondsToHHMMSS(
      (manualControlStatus.TotalRunTime - manualControlStatus.CurrentRunTime) / 1000,
    );

    return manualControlStatus.IsManualControlRunning === 'true' ? manualControlEstimateTime : normalEstimateTime;
  };

  percentageProgressbar = () => {
    const {isPCRunning, percentageProgressBar, currentVolume, manualControlStatus, ManualControlStartVolume} =
      this.props;
    const normalPercentageProgressBar =
      isPCRunning &&
      manualControlStatus.IsManualControlEnable === 'true' &&
      manualControlStatus.IsManualControlRunning !== 'true'
        ? PROGRESS_BAR_COMMON_VALUE.PERCENTAGE_MAX_OF_CONCENTRATE_DIAFILTRATION
        : percentageProgressBar;

    const timeToComplete =
      (Math.abs(Number(ManualControlStartVolume) - Number(currentVolume)) / Number(ManualControlStartVolume)) * 100;
    let manualControlProgressBar = Number(timeToComplete.toFixed(1));

    if (isNaN(manualControlProgressBar)) {
      manualControlProgressBar = 0;
    } else if (!isFinite(manualControlProgressBar)) manualControlProgressBar = 100;

    return manualControlStatus.IsManualControlRunning === 'true'
      ? manualControlProgressBar
      : normalPercentageProgressBar;
  };

  render() {
    const progressbarStyle = this.progressBarStyle();
    const progresbarLabel = this.progressBarLabel();
    const percentageProgress = this.percentageProgressbar();

    return (
      <div className="progress-bar-text">
        {!this.state.disableProgressBar && (
          <ProgressBar
            style={progressbarStyle}
            width="500px"
            height={this.props.isRemoteView ? '32px' : '48px'}
            progress={percentageProgress}
            label={progresbarLabel}
            isRemoteView={this.props.isRemoteView}
          />
        )}
      </div>
    );
  }
}
export default StatusProgress;
